import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import lang from '@/lang'
import FileExplorerDialog from '@/modules/file/components/file-explorer-dialog'
import { toast } from '@/modules/base/components/toast/toastConfig'
import { FILE_LIST_FILTER } from '@/modules/base/util/constants'

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexGrow: 1,
  },
}))

const TodoFileList = props => {
  const classes = useStyles(props)
  const {
    filter = FILE_LIST_FILTER.NO_SYSTEM_DOCUMENTS,
    onClose: onCloseHandler,
    onSelect: onSelectHandler,
    onPreview: onPreviewHandler,
    tenantCollaborationId,
  } = props

  const { error } = useSelector(state => state.document.list)

  useEffect(() => {
    if (error) {
      const message = lang.defaultErrorMessage
      toast.showToast({ type: 'error', message })
    }
  }, [error])

  const onSelectFile = file => {
    if (onSelectHandler) {
      onSelectHandler(file)
    }
  }

  const onClose = () => {
    if (onCloseHandler) {
      onCloseHandler()
    }
  }

  const handlePreview = (file, previewControlHandlers) => {
    if (onPreviewHandler) {
      onPreviewHandler(file, previewControlHandlers)
    }
  }

  return (
    <div className={classes.container}>
      <FileExplorerDialog
        tenantCollaborationId={tenantCollaborationId}
        onClose={onClose}
        onSelectFile={onSelectFile}
        previewDialog={handlePreview}
        displayClose={false}
        filter={filter}
      />
    </div>
  )
}

TodoFileList.propTypes = {
  onClose: PropTypes.func,
  onSelect: PropTypes.func,
  onPreview: PropTypes.func,
  filter: PropTypes.string,
  tenantCollaborationId: PropTypes.number,
}

export default TodoFileList
